import MicrosoftIcon from "../../../icons/microsoft";
import LoginButton from "../button";
import { LoginButtonProps } from "../types";
import useWebOAuthLogin from "../useWebOAuthLogin";

const Microsoft = (props: LoginButtonProps) => {
  const { label = "Iniciar sesión con Microsoft" } = props;
  const signIn = useWebOAuthLogin("microsoft", {
    endpoint: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
    clientId: "56fe1516-b774-48f0-b884-43066a6d051d",
    redirectPath: "/auth/microsoft",
    scope: "openid profile User.Read email",
    next: props.next,
    beforeSignIn: props.beforeSignIn,
  });

  return (
    <LoginButton
      label={label}
      Icon={MicrosoftIcon}
      loading={false}
      onPress={signIn}
      className={`bg-[#404040] gap-2 ${props.className ?? ""}`}
      textClassName="text-white stroke-transparent"
      variant="solid"
      size={props.size}
      rounded={props.rounded}
    />
  );
};

export default Microsoft;
